import TimeoutDialog from 'components/feedback/TimeoutDialog';
import { useDispatch, useSelector } from 'react-redux';
import { getSessionExpiredDialogOpen, hideSessionExpiredDialog } from 'store/slices/appSlice';

const SessionExpiredDialog = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector(getSessionExpiredDialogOpen);

    const handleConfirm = () => {
        dispatch(hideSessionExpiredDialog());
        window.location.reload();
    };

    return <TimeoutDialog id='session-expired' show={isOpen} onConfirm={handleConfirm} />;
};

export default SessionExpiredDialog;
